import { Fixture } from '../models/Fixture';
import { CACHE_KEYS } from './apiEndpoints';

export const TigersTeamName = 'Sheffield Ice Tigers';
export const HomeVenue = 'Ice Sheffield';
export const FixturesTableName = 'tigers_fixtures';

export type FixtureRecord = Fixture & {
  id?: string;
};

export function buildFixtureId(fixture: Pick<FixtureRecord, 'homeTeam' | 'awayTeam' | 'date'>): string {
  return `${fixture.homeTeam}_${fixture.awayTeam}_${fixture.date}`;
}

export function getFixtureId(fixture: FixtureRecord): string {
  return fixture.id ?? buildFixtureId(fixture);
}

export function formatFixtureLabel(fixture: FixtureRecord): string {
  return `${fixture.homeTeam} vs ${fixture.awayTeam} - ${fixture.date} ${fixture.time} (${fixture.venue})`;
}

export function getTigersHomeAway(fixture: FixtureRecord): 'home' | 'away' {
  return fixture.homeTeam === TigersTeamName ? 'home' : 'away';
}

export function getOpponent(fixture: FixtureRecord): string {
  return fixture.homeTeam === TigersTeamName ? fixture.awayTeam : fixture.homeTeam;
}

export function clearFixtureCaches(): void {
  Object.values(CACHE_KEYS)
    .filter((key) => key.startsWith('fixtures'))
    .forEach((key) => localStorage.removeItem(key));
}
